import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Model = () => {
  return (
    <SettingsMetaData propertyName={"VehicleModel"} viewPropertyName={"Vehicle Model"}/>
  );
};

export default Model;
